import { formatCount, intlLocale } from "@ghezaa/ui";
import type { TargetMeasure } from "@/api/client";
import { compact, money, percent } from "./format";

/** The measures a target can be set on, in the order a manager usually weighs them (docs/sales-plan.md §5). */
export const measures: TargetMeasure[] = ["Revenue", "GrossProfit", "Margin", "Customers", "NewCustomers", "LinesPerInvoice"];

export const measureWord: Record<TargetMeasure, string> = {
  Revenue: "Revenue",
  GrossProfit: "Gross profit",
  Margin: "Margin",
  Customers: "Customers who bought",
  NewCustomers: "New customers",
  LinesPerInvoice: "Lines an invoice",
};

/** Money measures are typed and shown in the market's money; margin as a percentage; the rest as counts. */
export const isMoney = (m: TargetMeasure) => m === "Revenue" || m === "GrossProfit";

/** A measure's figure as a person reads it: `2,500,000`, `25%`, `40`, `3.5`. */
export function figure(m: TargetMeasure, value: number, short = false): string {
  if (isMoney(m)) return short ? compact(value) : money(value);
  if (m === "Margin") return percent(value);
  if (Number.isInteger(value)) return formatCount(value);
  return value.toLocaleString(intlLocale(), { maximumFractionDigits: 1 });
}
